import { InjectionToken } from '@angular/core';
import { IWebStorageService } from '@seech/core-ng';

export const WEB_STORAGE = new InjectionToken<IWebStorageService>('WEB_STORAGE');
